var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.6668C0.966667 13.6668 0.652667 13.5364 0.391333 13.2755C0.130444 13.0142 0 12.7002 0 12.3335V3.00016H1.33333V12.3335H8.66667V13.6668H1.33333ZM4 11.0002C3.63333 11.0002 3.31956 10.8697 3.05867 10.6088C2.79733 10.3475 2.66667 10.0335 2.66667 9.66683V1.66683C2.66667 1.30016 2.79733 0.986163 3.05867 0.724829C3.31956 0.46394 3.63333 0.333496 4 0.333496H10C10.3667 0.333496 10.6807 0.46394 10.942 0.724829C11.2029 0.986163 11.3333 1.30016 11.3333 1.66683V9.66683C11.3333 10.0335 11.2029 10.3475 10.942 10.6088C10.6807 10.8697 10.3667 11.0002 10 11.0002H4ZM4 9.66683H10V1.66683H4V9.66683Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.eff9c080603ffc0ffcc6ff8c04bf8fd8.svg";
export { ForwardRef as ReactComponent };